import { Injectable } from '@angular/core';
import { Constructor, JsonTypes } from '@web/utils';
import { TypedJSON } from 'typedjson';

@Injectable({
  providedIn: 'root',
})
export class JsonTransformerService {
  public toObject<ObjectType, Plain>(
    json: Plain,
    type: Constructor<ObjectType>,
  ): ObjectType {
    return TypedJSON.parse(json, type);
  }

  public toArray<ObjectType, Plain>(
    json: Plain[],
    type: Constructor<ObjectType>,
  ): ObjectType[] {
    return TypedJSON.parseAsArray(json, type);
  }

  public toJson<ObjectType>(
    object: ObjectType,
    type: Constructor<ObjectType>,
  ): JsonTypes {
    return TypedJSON.toPlainJson(object, type);
  }

  public toJsonArray<ObjectType>(
    object: ObjectType[],
    type: Constructor<ObjectType>,
  ): JsonTypes[] {
    return TypedJSON.toPlainArray(object, type);
  }

  public stringify<ObjectType>(
    value: ObjectType,
    type: Constructor<ObjectType>,
  ): string {
    return TypedJSON.stringify(value, type);
  }

  public stringifyAsArray<ObjectType>(
    value: ObjectType[],
    type: Constructor<ObjectType>,
  ): string {
    return TypedJSON.stringifyAsArray(value, type);
  }

  public parse<ObjectType>(
    value: string,
    type: Constructor<ObjectType>,
  ): ObjectType {
    return TypedJSON.parse(value, type);
  }

  public parseAsArray<ObjectType>(
    value: string,
    type: Constructor<ObjectType>,
  ): ObjectType[] {
    return TypedJSON.parseAsArray(value, type);
  }
}
